export default __webpack_public_path__ + "static/media/Lock.ae45d1ad.svg";